// extracted by mini-css-extract-plugin
module.exports = {"success":"success__10fnW","icon":"icon__2Xru3","h3":"h3__34Bdb","p":"p__3Ch2M"};